import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SessionsWorkspace } from '@/features/sessions/components/workspace/SessionsWorkspace';
import { requirePermission } from '@/lib/guards';

const segmentSchema = z.enum(['all', 'today', 'upcoming', 'high-risk', 'no-show']).default('all');
const panelSchema = z.enum(['session', 'client']).optional();
const drawerTabSchema = z
  .enum(['overview', 'notes', 'transcript', 'case-reports', 'feedback'])
  .default('overview');

const workspaceSearchSchema = z
  .object({
    client: z.string().optional(),
    panel: panelSchema,
    id: z.string().optional(),
    drawerTab: drawerTabSchema,
    q: z.string().optional(),
    segment: segmentSchema,
    status: z.array(z.string()).optional(),
    risk: z.array(z.string()).optional(),
    from: z.string().optional(),
    to: z.string().optional(),
  })
  .transform((val) => {
    // Strip both panel and id if either is missing — invalid params reset to defaults.
    if (!val.panel || !val.id) {
      return { ...val, panel: undefined, id: undefined };
    }
    return val;
  });

export type WorkspaceSearch = z.infer<typeof workspaceSearchSchema>;

export const Route = createFileRoute('/app/sessions/')({
  beforeLoad: () => {
    requirePermission('session:read');
  },
  validateSearch: (raw: Record<string, unknown>) => {
    if (raw.drawerTab === 'post-session') {
      return workspaceSearchSchema.parse({ ...raw, drawerTab: 'notes' });
    }
    return workspaceSearchSchema.parse(raw);
  },
  component: SessionsWorkspace,
  staticData: { crumb: 'Sessions', fullBleed: true },
});
